import {APP_INITIALIZER, LOCALE_ID, ModuleWithProviders, NgModule, provideZoneChangeDetection} from '@angular/core';
import {CommonModule} from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {LocalizationService} from "./localization.service";

@NgModule({ declarations: [],
    exports: [TranslateModule], imports: [CommonModule, TranslateModule.forChild()], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class LocalizationModule {
  public static forRoot(config: any): ModuleWithProviders<TranslateModule> {
    return {
      ngModule: LocalizationModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: initLocalizationService,
          deps: [LocalizationService],
          multi: true
        },
        TranslateService,
        { provide: LOCALE_ID, useValue: 'en' }, // using the initial value
        provideZoneChangeDetection()
      ]
    };
  }
}

export function initLocalizationService(service: LocalizationService) {
  const result = service.initService()
  return () => result;
}
